import { useEffect, useState } from "react";
import api from "../lib/api";
import { ChevronDown, Wifi } from "lucide-react";

const KEY = "pgp_sa_connected_open";
const fmt = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");

export const ConnectedUsersPanel = () => {
  const [open, setOpen] = useState(() => localStorage.getItem(KEY) !== "0");
  const [rows, setRows] = useState([]);
  const toggle = () => setOpen((o) => { localStorage.setItem(KEY, o ? "0" : "1"); return !o; });

  useEffect(() => {
    if (!open) return undefined;
    const load = () => api.get("/admin/connected-users").then(({ data }) => setRows(data)).catch(() => {});
    load();
    const id = setInterval(load, 30000);
    return () => clearInterval(id);
  }, [open]);

  const online = rows.filter((r) => r.online).length;
  return (
    <div className="pgp-card mt-6" data-testid="connected-users-panel">
      <button type="button" onClick={toggle} data-testid="connected-users-toggle"
        className="w-full flex items-center justify-between gap-3 px-5 py-4 text-left">
        <span className="flex items-center gap-2 font-head font-semibold text-slate-100">
          <Wifi className="h-4 w-4 text-emerald-400" /> Utenti Connessi
          <span className="text-xs font-normal text-slate-400" data-testid="connected-users-count">{online} online</span>
        </span>
        <ChevronDown className={`h-4 w-4 text-slate-400 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="overflow-x-auto border-t border-slate-800">
          <table className="w-full text-sm" data-testid="connected-users-table">
            <thead><tr className="text-left text-xs uppercase tracking-wide text-slate-500">
              <th className="px-5 py-2.5">Stato</th><th className="px-3 py-2.5">Nome</th><th className="px-3 py-2.5">Email</th>
              <th className="px-3 py-2.5">Studio</th><th className="px-3 py-2.5">Ultimo accesso</th>
            </tr></thead>
            <tbody>
              {rows.length === 0 && <tr><td colSpan={5} className="px-5 py-6 text-center text-slate-500">Nessun accesso registrato.</td></tr>}
              {rows.map((r) => (
                <tr key={r.id} className="border-t border-slate-800/70" data-testid={`connected-user-${r.id}`}>
                  <td className="px-5 py-2.5 whitespace-nowrap">
                    <span className={`inline-flex items-center gap-1.5 text-xs font-medium ${r.online ? "text-emerald-400" : "text-slate-500"}`} data-testid={`connected-user-status-${r.id}`}>
                      <span className={`h-2.5 w-2.5 rounded-full ${r.online ? "bg-emerald-500 shadow-[0_0_6px_rgba(16,185,129,0.8)] animate-pulse" : "bg-slate-600"}`} />
                      {r.online ? "Online" : "Offline"}
                    </span>
                  </td>
                  <td className="px-3 py-2.5 text-slate-100">{r.name || "—"}</td>
                  <td className="px-3 py-2.5 text-slate-300 break-all">{r.email}</td>
                  <td className="px-3 py-2.5 text-slate-300">{r.studio || "—"}</td>
                  <td className="px-3 py-2.5 text-slate-300 whitespace-nowrap">{fmt(r.last_seen_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
